import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Carousel = ({ data = [], title, onCompanyClick }) => {
  const uniqueData = Array.from(new Set(data.map(item => item._id))).map(id =>
    data.find(item => item._id === id)
  );

  const slidesToShow = Math.min(3, uniqueData.length);
  const slidesToScroll = Math.min(3, uniqueData.length);

  const settings = {
    infinite: uniqueData.length > slidesToShow,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: slidesToScroll,
    arrows: uniqueData.length > 1,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: Math.min(1, uniqueData.length),
          slidesToScroll: Math.min(1, uniqueData.length),
          infinite: uniqueData.length > 1,
          arrows: uniqueData.length > 1,
        },
      },
    ],
  };

  return (
    <div className="bg-white mt-4 h-[350px] p-6">
      {/* Header  */}
      <div className="flex justify-between items-center px-2 pb-2">
        <p className="font-sans text-sm font-normal text-[#191B1C]">{title}</p>
      </div>
      {uniqueData.length === 0 ? (
        <div className="text-center py-10 text-gray-500">No items to display</div>
      ) : uniqueData.length === 1 ? (
        <div className="w-full max-w-[750px] flex justify-start">
          <div className="p-2" style={{ margin: '0 10px' }}>
            <button
              className="w-[250px] cursor-pointer"
              onClick={() => onCompanyClick(uniqueData[0]?._id)}>
              <div className="mx-2 border border-gray-200 p-2 pb-2 rounded-lg overflow-hidden h-[250px] flex flex-col">
                <img
                  src={uniqueData[0]?.profilePic || uniqueData[0]?.media[0]?.fileUrl}
                  alt={uniqueData[0]?.name}
                  className="w-full h-36 object-cover rounded-lg"
                />
                <div className="py-2 px-1 text-left">
                  <div className="inline-block px-2 py-1 border border-black rounded-lg">
                    <h3 className="font-normal text-sm">{uniqueData[0]?.name}</h3>
                  </div>
                  <p className="w-full text-xs font-nohemi font-light text-gray-600 mt-1 line-clamp-3">
                    {uniqueData[0]?.bio}
                  </p>
                </div>
              </div>
            </button>
          </div>
        </div>
      ) : (
        <div className="w-full max-w-[750px]">
          <Slider {...settings}>
            {uniqueData.map(item => (
              <div key={item._id} className="p-2" style={{ margin: '0 10px' }}>
                <button
                  className="w-[250px] cursor-pointer"
                  onClick={() => onCompanyClick(item?._id)}>
                  <div className="bg-white mx-2 shadow-sm p-2 pb-2 rounded-lg overflow-hidden h-[250px] flex flex-col">
                    <img
                      src={item?.profilePic || item?.media[0]?.fileUrl}
                      alt={item?.name}
                      className="w-full h-36 object-cover rounded-lg"
                    />
                    <div className="py-2 px-1 text-left">
                      <div className="inline-block px-2 py-1 border border-black rounded-lg">
                        <h3 className="font-normal text-xs">{item?.name}</h3>
                      </div>
                      <p className="w-full text-[10px] font-nohemi font-light text-gray-600 mt-1 line-clamp-3">
                        {item?.bio}
                      </p>
                    </div>
                  </div>
                </button>
              </div>
            ))}
          </Slider>
        </div>
      )}
    </div>
  );
};

Carousel.propTypes = {
  title: PropTypes.string,
  visibleCards: PropTypes.number,
  onCompanyClick: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      profilePic: PropTypes.string,
      media: PropTypes.arrayOf(
        PropTypes.shape({
          fileUrl: PropTypes.string,
        })
      ),
      name: PropTypes.string,
      bio: PropTypes.string,
    })
  ).isRequired,
};

export default Carousel;
